import React, { FocusEvent } from 'react'
import { useFormContext } from 'react-hook-form'
import { mixinInputFormClasses } from 'spa/member/styles/mixin'
import { FormErrorMessage } from 'spa/member/components/FormErrorMessage'
import { InputProps } from './types'

export const StyledInput: React.FC<InputProps> = props => {
  const { register, formState: { errors } } = useFormContext()

  const hasError = !!errors[props.name]
  const baseClassName = 'disabled:bg-member-gray-30'
  const mixinClassName = mixinInputFormClasses(hasError, props.inputSize)
  const className = [baseClassName, props.className || '', mixinClassName].filter(Boolean).join(' ')
  const height = props.inputSize === 'small' ? '39px' : '50px'

  return (
    <div className={props.containerClass}>
      <input {...Object.fromEntries(Object.entries(props).filter(([key, _value]) => !['rules', 'inputSize', 'containerClass'].includes(key)))}
        {...register(props.name, { ...props.rules, onBlur: (e: FocusEvent<HTMLInputElement, Element>): void => props.onBlur && props.onBlur(e) })}
        className={className} style={{ height }} />
      {hasError && <FormErrorMessage message={String(errors[props.name]?.message)} />}
    </div>
  )
}
